import { DataViewerCardMenu } from '@leverege/molten/data-viewers';
import ProgressCardModel from './progressCard/ProgressCardModel';
import ProgressCardViewer from './progressCard/ProgressCardViewer';
import ResultsTableModel from './resultsTable/ResultsTableModel';
import ResultsTableViewer from './resultsTable/ResultsTableViewer';
export default {
  install(molten) {
    molten.addPlugin('DashboardItem', {
      type: ProgressCardModel.TYPE,
      model: ProgressCardModel,
      viewer: ProgressCardViewer,
      menuEditor: DataViewerCardMenu,
      name: 'Progress Card',
      icon: null
    });
    molten.addPlugin('DashboardItem', {
      type: ResultsTableModel.TYPE,
      model: ResultsTableModel,
      viewer: ResultsTableViewer,
      menuEditor: DataViewerCardMenu,
      name: 'Job Items Table',
      icon: null
    });
  }
};